import React, { StrictMode } from 'react';

import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { TranslationContextProvider } from './context/translations';
import App from './App';

import './styles/global.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <StrictMode>
    <BrowserRouter>
      <TranslationContextProvider>
        <App />
      </TranslationContextProvider>
    </BrowserRouter>
  </StrictMode>,
);
